export default function EventInfo() {
  return (
    <section id="sobre" className="py-24 bg-[#CDE3BB]/20">
      <div className="max-w-6xl mx-auto px-6">

        <div className="flex flex-col items-center text-center mb-16">
          <span className="inline-block bg-[#BCD033] text-white text-xs font-bold px-4 py-1.5 rounded-full tracking-widest uppercase mb-5">
            3ª Edição · 2026
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#008C51] leading-tight max-w-3xl">
            Toda grande mudança começa com um{" "}
            <span className="text-[#BCD033]">primeiro movimento.</span>
          </h2>
          <p className="text-gray-500 mt-5 text-lg font-light max-w-2xl leading-relaxed">
            Uma manhã dedicada ao cuidado com a saúde, ao bem-estar e à descoberta de novas formas de se movimentar.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">

          <div className="space-y-5 text-gray-600 text-base leading-relaxed">
            <p>
              Em sua <strong className="text-[#008C51] font-bold">3ª edição</strong>, o{" "}
              <strong className="text-[#BCD033] font-bold">Mude1Hábito Experience</strong> convida você para uma
              manhã dedicada ao cuidado com a saúde, ao bem-estar e à descoberta de novas formas de se movimentar.
            </p>
            <p>
              A Arena 4Set, no Buritis, recebe uma programação pensada para diferentes ritmos e objetivos. Ao longo da manhã, os participantes
              poderão experimentar uma variedade de modalidades em um ambiente preparado para acolher, ativar e inspirar.
            </p>
            <p>
              Nesta edição, a experiência foi construída em dois momentos complementares. Primeiro, práticas voltadas
              para o cuidado da <strong className="text-[#008C51]">mente</strong> estimulam presença, respiração e
              consciência corporal. Em seguida, atividades mais dinâmicas exploram o movimento do{" "}
              <strong className="text-[#008C51]">corpo</strong>, energia e interação.
            </p>
            <p className="italic text-[#008C51] font-medium text-lg border-l-4 border-[#BCD033] pl-4">
              Vamos começar de dentro para fora, ganhando ritmo ao longo da manhã.
            </p>
          </div>

          <div className="flex flex-col gap-4">
            {[
              {
                icon: "ri-calendar-event-line",
                label: "Data",
                value: "12 de abril de 2026",
                sub: "Domingo",
                bg: "bg-[#CDE3BB]",
                iconBg: "bg-[#BCD033]",
              },
              {
                icon: "ri-time-line",
                label: "Horário",
                value: "07h30 às 12h00",
                sub: "Manhã completa",
                bg: "bg-[#F0CDCD]/60",
                iconBg: "bg-[#F0CDCD]",
              },
            ].map((item, i) => (
              <div
                key={i}
                className={`flex items-center gap-4 ${item.bg} rounded-2xl px-5 py-4`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${item.iconBg} shrink-0`}>
                  <i className={`${item.icon} text-white text-xl`} />
                </div>
                <div>
                  <p className="text-[#008C51] text-xs font-bold tracking-widest uppercase mb-0.5">{item.label}</p>
                  <p className="text-[#008C51] font-extrabold text-base leading-tight">{item.value}</p>
                  <p className="text-gray-500 text-xs mt-0.5">{item.sub}</p>
                </div>
              </div>
            ))}

            <a
              href="https://maps.google.com/?q=R.+Líbero+Leone,+259+Buritis+Belo+Horizonte"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex items-center gap-4 bg-[#C8E3F5]/50 rounded-2xl px-5 py-4 cursor-pointer hover:bg-[#C8E3F5]/80 transition-colors duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#4A90D9] shrink-0">
                <i className="ri-map-pin-2-line text-white text-xl" />
              </div>
              <div className="flex-1">
                <p className="text-[#008C51] text-xs font-bold tracking-widest uppercase mb-0.5">Local</p>
                <p className="text-[#008C51] font-extrabold text-base leading-tight">Arena 4Set · Buritis</p>
                <p className="text-gray-500 text-xs mt-0.5">R. Líbero Leone, 259 — Buritis, Belo Horizonte, MG</p>
                <p className="text-[#4A90D9] text-xs mt-1 font-semibold flex items-center gap-1">
                  <i className="ri-external-link-line" /> Ver no Google Maps
                </p>
              </div>
            </a>

            <div className="flex items-center gap-4 bg-[#008C51] rounded-2xl px-5 py-4 mt-1">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#BCD033] shrink-0">
                <i className="ri-gift-line text-white text-xl" />
              </div>
              <div>
                <p className="text-[#CDE3BB] text-xs font-bold tracking-widest uppercase mb-0.5">Participação</p>
                <p className="text-white font-extrabold text-base leading-tight">Evento 100% gratuito</p>
                <p className="text-white/60 text-xs mt-0.5">Mediante inscrição prévia · Inscrições a partir de 02/04, às 10h</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white rounded-2xl p-7 border border-[#BCD033]/30 hover:-translate-y-1 transition-transform duration-200">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-[#CDE3BB] rounded-xl">
                <i className="ri-mental-health-line text-[#008C51] text-xl" />
              </div>
              <div>
                <p className="text-xs font-bold text-[#BCD033] tracking-widest uppercase">1º Momento · 08h30–10h00</p>
                <h3 className="text-[#008C51] font-extrabold text-lg leading-tight">Modalidades Mente</h3>
              </div>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed">
              Práticas voltadas para o cuidado da mente: presença, respiração e consciência corporal.
              Meditação, Yoga, Tai Chi Chuan, LPF e Mobilidade Articular — 1 aula por pessoa.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-7 border border-[#F0CDCD]/50 hover:-translate-y-1 transition-transform duration-200">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-[#F0CDCD]/60 rounded-xl">
                <i className="ri-run-line text-[#008C51] text-xl" />
              </div>
              <div>
                <p className="text-xs font-bold text-[#F0CDCD] tracking-widest uppercase" style={{ filter: "brightness(0.7)" }}>2º Momento · 10h20–11h40</p>
                <h3 className="text-[#008C51] font-extrabold text-lg leading-tight">Modalidades Corpo</h3>
              </div>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed">
              Atividades dinâmicas que exploram movimento, energia e interação.
              Mix de Danças, Funcional, Beach Tennis e Padel — 1 aula por pessoa.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}
